import { useCan } from "components";
import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { useThreeDepartmentFilters } from "modules/ThreeDepartmentDashboard/hooks/useThreeDepartmentFilters";
import { useThreeDepartmentListeners } from "modules/ThreeDepartmentDashboard/listeners";
import { threeDepartmentQueryKeys } from "modules/ThreeDepartmentDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useThreeDepartmentList = () => {
  const filters = useThreeDepartmentFilters();
  const listeners = useThreeDepartmentListeners();
  const canList = useCan("list", "appointments-three-departments");

  const { data, isFetching } = useRealTimeTypedQuery({
    queryKey: threeDepartmentQueryKeys.list,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, filters, baseUrl)).data,
    enabled: canList && filters.dealer_location_id !== null,
    refetchOnDependencies: [filters],
    listeners
  });

  return {
    items: data?.items ?? [],
    nbItems: data?.nb_items ?? 0,
    nbPages: data?.nb_pages ?? 1,
    isFetching
  };
};
